import { useQuery } from '@tanstack/react-query'
import { trainingService } from '@/services/api/trainingService'

/**
 * Hook that checks broker certification status.
 * When isGateActive = true, the broker should only see Learning & Certification modules.
 */
export function useBrokerCertificationGate(isBroker: boolean) {
  const { data, isLoading } = useQuery({
    queryKey: ['broker', 'certification-status'],
    queryFn: () => trainingService.getCertificationStatus(),
    enabled: isBroker,
    staleTime: 2 * 60 * 1000, // 2 min cache
  })

  return {
    isCertified: data?.is_certified ?? false,
    hasPendingTraining: data?.has_pending_training ?? false,
    pendingCount: data?.pending_enrollments_count ?? 0,
    activeCertifications: data?.active_certifications ?? [],
    enrollments: data?.enrollments ?? [],
    isLoading: isBroker && isLoading,
    isGateActive: isBroker && !isLoading && !data?.is_certified,
  }
}
